import React from 'react';
import { Card, Row } from 'react-bootstrap';
import FormCreatePerson from '../components/FormCreatePerson';

function CreatePerson() {

    return (
        <div>
            <Row>
                <div className='col-12'>
                    <Card>
                        <Card.Body>
                            <h4 className="card-title">Registrar nuevo Cliente</h4>
                            <FormCreatePerson />
                        </Card.Body>
                    </Card>
                </div>
            </Row>
        </div>
    );
}

export default CreatePerson;